import axios from "axios"

import { Toast } from "vant"

// const BASE_API = window.location.origin;
// var a = 'http://hnszgh.w.chineseall.cn'

// var b = a.replace('.w.','.cahd.');

// console.log(BASE_API)
// console.log("接口请求地址是："+process);
// console.log(process.env);
const BASE_API = "https://visitor.api.chineseall.cn/api";
// const BASE_API = window.location.origin.replace('.w.','.cahd.');
console.log("BASE_API:",BASE_API);  
const httpRequest = axios.create({
	baseURL: BASE_API, //cockpit是后端工程名
	timeout: 1000 * 60   // 超时设置
})

// // 拦截请求，由于设置了headers，变为非简单请求，后台需设置 Access-Control-Allow-Methods、Access-Control-Allow-Headers
httpRequest.interceptors.request.use(
	config => {
		// 获取请求地址
		// let reqPath = config.url.replace(config.baseURL, "")
		// 加loading
		Toast.loading({
			duration: 0, // 持续展示 toast
			message: '加载中...',
			forbidClick: true,
			loadingType: 'spinner',
		});
		
		// app调用H5页面时需传入token, 每个请求都携带token
		// let token = sessionStorage.token? 'Bearer ' + sessionStorage.token : "",
		// 		userid = window.sessionStorage.getItem('userid') || '';

		// Object.assign(config.headers, {
		// 	"security": 'ChineseAll&*(',
		// })
		config.data = {
			// 'loginUserId': userid,
			...config.data
		}

		return config
	},
	error => {
		// Do something with request error
		console.log(error) // for debug
		Promise.reject(error)
	}
)

httpRequest.interceptors.request.use(
	config => {
	  // do something before request is sent
  
	//   if (store.getters.token) {
	// 	// let each request carry token
	// 	// ['X-Token'] is a custom headers key
	// 	// please modify it according to the actual situation
	// 	config.headers['X-Token'] = getToken()
	//   }
	  return config
	},
	error => {
	  // do something with request error
	  console.log(error) // for debug
	  return Promise.reject(error)
	}
  )

// 拦截响应
httpRequest.interceptors.response.use(
	res => {
		
		Toast.clear(); // 关闭lodding
		if (res.data) {
			return res.data
		} else {
			Toast({
				message: '服务器错误',
				duration: 2000
			});
			return Promise.reject(new Error("error")).catch((e) => { console.log("error:", e) });
		}
	},
	err => {
		console.log("response:", err.response);
		if (err && err.response) {
			// 拦截401
			// switch (err.response.status) {
			// 	case 401:
			// 		err.message = "该功能未开放";
			// 		// 跳转未授权页面
			// 		window.globalVue.$router.push({
			// 			path: "/permissionPage"
			// 		});
			// 		break;
			// 	default:
			// 		err.message = `服务异常${err.response.status}`
			// 		break;
			// }
		} else {
			err.message = "服务异常，数据加载失败!"
		}
		Toast.clear(); // 关闭lodding
		Toast({
			message: err.message,
			duration: 3000
			// position: 'bottom'
		});
		return Promise.reject(err).catch((e) => { console.log("error:", e) });
	}
)

export {
	httpRequest,
	BASE_API
}
